<template>
    <v-container>
        <v-card>
            <v-row wrap>
                <v-col xs12 sm12 md12>
                    <v-card-text>
                        <h2 class="mt-3">推播對象</h2>
                        <div class="mt-1" style="border: 1px solid #aaa; padding: 10px; border-radius: 5px; solid; overflow: auto; background: #f5f5f5;">
                            <v-radio-group v-model="group" @change="choose_user(); " column>
                                <!-- <v-radio :label="'帳號所有好友（目前帳號人數為：'+ line_account_friends +'人, LINE1.0無法使用此推播)'" value="Broadcast"></v-radio> -->
                                <v-radio :label="'全部有效好友（目前有效好友為：'+ all_validated_user +'人)'" value="All" :disabled="all_validated_user===0"></v-radio>
                                <v-radio label="分眾推播" value="Group" :disabled="group_list.length == 0"></v-radio>
                            </v-radio-group>

                            <v-select  
                                v-model="select_group"  
                                :items="group_list"
                                @change="choose_group();" 
                                :disabled="group == 'All'" 
                                item-text="name" 
                                item-value="id" 
                                label="選擇分類"  
                                solo></v-select>
                            <!-- <v-radio-group v-model="set_type" @change="group='Group'; set_hint_text(set_type); checkUser();" row>
                                <v-radio label="交集" value="intersection" :disabled="select_group.length===0 || group_list.length == 0 || group==='All'" ></v-radio>
                                <v-radio label="聯集" value="union" :disabled="select_group.length===0 || group_list.length == 0 || group==='All'" ></v-radio>
                            </v-radio-group> -->
                            <p v-show="hint_text" style="font-size: 15px; color: black;">{{ hint_text }}</p>
                        </div>
                        <h2 class="mt-3">推播內容</h2>
                        <div class="mt-1" style="border: 1px solid #aaa; padding: 10px; border-radius: 5px; solid; overflow: auto; background: #f5f5f5;">
                            <div class="mt-3" v-for="(ml, ml_index) in messageList" :key="ml_index" style="border: 1px solid #f5f5f5; padding: 5px; border-radius: 5px; solid; background: #ddd;">
                                <v-col xs12 wrap v-if="ml.type === 'text'">
                                    <span>文字訊息 </span>
                                    <v-icon @click="messageList.splice(ml_index, 1), $store.commit('setEditAlert', true);" style="float: right;">mdi-close</v-icon>
                                    <v-textarea 
                                        id='ml_message'  
                                        v-model="ml.message" 
                                        v-on:focus="textarea_input(ml.message, ml_index), $store.commit('setEditAlert', true)" 
                                        single-line 
                                        counter="2000"
                                        maxlength="2000"
                                        solo 
                                        outlined 
                                        no-resize
                                        label="訊息內容">
                                    </v-textarea>
                                </v-col>
                            </div>
                        </div>
                        <br/>
                        <!-- <v-btn small @click="choose_type('text'), $store.commit('setEditAlert', true)" :disabled="messageList.length >= 5"> -->
                        <v-btn small @click="choose_type('text');" :disabled="messageList.length >= 5">
                            <v-icon>mdi-plus</v-icon>
                            文字訊息
                        </v-btn>
                    </v-card-text>
                    <v-card-actions>
                        <v-col>
                            <v-btn color="success" @click="push_submit" block>送出訊息</v-btn>
                        </v-col>
                    </v-card-actions>
                </v-col>
            </v-row>
        </v-card>
        <!-- 確認訊息送出Dialog -->
        <v-dialog v-model="checkDialogVisible" persistent width="500" scrollable>
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>提示
                    <v-spacer/>
                    <v-icon @click="checkDialogVisible=false">mdi-close</v-icon>
                </v-card-title>

                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md12>
                            <br/>
                            確定要送出訊息？
                        </v-flex>
                    </v-layout>
                </v-card-text>
                
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn id='checkNo' color="error" @click="checkDialogVisible=false">取消</v-btn>
                    <v-btn id='checkYes' color="success" @click="checkDialogVisible=false; check_submit=true; submit(); check_submit=false;" :disabled="check_submit">確認</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import bus from '../nav/bus'

import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css'

var host_url = process.env.VUE_APP_HOST_URL
export default {
    components: {Datetime},
    data(){
        return {
            notification_name: '',
            group: 'All',
            // line_account_friends: 1,
            all_validated_user: 0,
            // 選擇集合
            group_list: [],
            select_group: '',
            set_type: '',
            hint_text: '',

            // 確認訊息
            checkDialogVisible: false,
            check_submit: false,
            // 推播內容
            messageList: [],

            name: '',

            user_list: 0,

        }
    },
    created(){
        this.getUsers()
        this.getTags()
    },
    methods: {
        getUsers(){
            axios.get(host_url+'get_valid_friends/')
            .then(response => {
                let tmp = response.data
                if(tmp.status ==true){
                    // console.log(tmp.data)
                    // console.log(' get valid true')
                    this.all_validated_user = tmp.data
                }
                else{
                }
                
            })
            .catch((error) => {
                console.log(error)
            })
        },
        choose_group(){
            this.getTags()
            this.group = 'Group';
            this.user_list = this.select_group
            // this.set_hint_text(this.set_type);
        },
        choose_user(){
            if (this.group === "All"){
                this.hint_text='';
                this.user_list=0;
                this.select_group = '';
                this.set_type = '';
            }
            else if (this.group === "Group"){
                this.user_list = this.select_group;
                // console.log(this.user_list)
                this.set_type = 'union';
            }
        },
        getTags(){
            axios.get(host_url+'get_tags/')
            .then(response => {
                let tmp = response.data
                if(tmp.status ==true){
                    // console.log(this.group_list)
                    this.group_list = tmp.data
                }
                else{
                    // bus.$emit('alert', {'title': '提示!', 'check': '我知道了', 'msg': '無標籤'})
                }
                
            })
            .catch((error)=>{
                console.log(error)
            })
        },
        choose_type(type_name){
            // 新增類別到 messageList
            this.add_messageList(type_name);
        },
        add_messageList(type_name){
            if (type_name == "text"){
                this.messageList.push({"type": type_name,
                                    "message": "",});
            }
        },
        // enter text message content
        textarea_input(ml_content, mlid) {
            this.messageList[mlid].message = ml_content;
        },
        getUserList(){
            // console.log('getUserList++++++')
            if (this.name != ''){
                axios.get(host_url+"get_username_list?name="+this.name)
                .then(response => {
                    let tmp = response.data
                    if(tmp.status == true) {
                        this.list_search = tmp.user_list;
                        // console.log(this.list_search)
                        // console.log(tmp)
                    }
                })
                .catch( (error)=> {
                    // this.$ga.event('admin_search', 'getUserList', 'Error')
                    console.log(error);
                });
            }
        },
        push_submit(){
            // if(localStorage.getItem('link_bot') == 'false'){
            //     bus.$emit('link_token')
            //     return
            // }

            this.checkDialogVisible = true
        },
        submit() {
            // console.log('submit')
            // console.log(this.user_list)
     
            if( this.group == 'All'){
                if (this.all_validated_user == 0){
                    bus.$emit('alert', {'title': '提示!', 'check': '我知道了', 'msg': '有效好友人數為 0'})
                    return 
                }
            }
            if (this.user_list === '' || this.user_list === undefined || this.user_list === null){
                // console.log('userlist is none')
                bus.$emit('alert', {'title': '必填提示!', 'check': '我知道了', 'msg': '請選擇分類'})
                return false
            }
            else if (this.messageList.length === 0){
                // console.log('no message')
                bus.$emit('alert', {'title': '必填提示!', 'check': '我知道了', 'msg': '請輸入推播內容'})
                return false
            }
            for (let key of this.messageList){
                if (key.message === ""){
                    bus.$emit('alert', {'title': '必填提示!', 'check': '我知道了', 'msg': '文字訊息尚未輸入'});
                    return false
                }
            }
            // console.log('no error')
            let data = {
                push_at: new Date(),
                user_list: this.user_list,
                message: this.messageList
            }

            bus.$emit('update', {msg: '發送中...'})
            axios.post(host_url+"send_msg/", JSON.stringify(data))
            .then((response) => {
                bus.$emit('close_update')
                let tmp = response.data;
                // console.log(tmp);
                if(tmp.status === true){
                    bus.$emit('alert', {'title': '提示!', 'check': '我知道了', 'msg': '送出成功!!'})
                }
                else{
                    
                    bus.$emit('alert', {'title': '錯誤提示!', 'check': '我知道了', 'msg': tmp.msg})
                    
                    }
            })
            .catch((error)=> {
                bus.$emit('close_update')
                // this.$ga.event('push_message', 'submit_if_false', 'Error')
                console.log(error);
            });

        },
        set_hint_text(set_text){

            if (set_text === "union"){
                this.hint_text = '推播給擁有'

                for (let [i, key] of this.select_group.entries()){
                    let obj = this.group_list.find((item)=>{
                        return item.id === key;
                    });
                    if (i+1 === this.select_group.length){
                        this.hint_text += obj.name;
                    }
                    else{ this.hint_text += obj.name+"或";}
                }
                this.hint_text += "Tag的使用者";
            }
            else if (set_text === "intersection"){
                this.hint_text = '推播給同時擁有'
                for (let [i, key] of this.select_group.entries()){
                    let obj = this.group_list.find((item)=>{
                        return item.id === key;
                    });
                    if (i+1 === this.select_group.length){
                        this.hint_text += obj.name;
                    }
                    else{ this.hint_text += obj.name+",";}
                }
                this.hint_text += "Tag的使用者";
            }
            else{
                this.hint_text = '';
            }
        },
    }
}
</script>